<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        color="primary"
        class="ma-1"
        :disabled="!$permission('127')"
      >
        <v-icon left>
          mdi-plus-box
        </v-icon>
        {{ $t("createNewWebhook") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>
          {{ $t("createNewWebhook") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form
        v-model="form.valid"
        class="pa-4 px-2"
        @submit.prevent="createWebhook"
      >
        <v-card-text>
          <v-text-field
            v-model="form.url"
            label="URL"
            placeholder="https://suaapi.com/v2/endpoint"
            required
            type="url"
            solo-inverted
            dense
            :rules="[rules.required, validUrl]"
          ></v-text-field>
          <v-select
            v-model="form.type"
            :items="options.types"
            label="Tipo"
            value="value"
            required
            dense
            solo-inverted
            :rules="[rules.required]"
          ></v-select>
        </v-card-text>
        <v-card-actions class="pt-4 px-4">
          <v-spacer></v-spacer>
          <v-btn
            :block="$vuetify.breakpoint.smAndDown"
            color="info"
            @click="createWebhook"
            :disabled="!form.valid"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";

export default {
  data: (vm) => ({
    dialog: false,
    form: {
      valid: false,
      url: "",
      type: "",
    },
    options: {
      types: [
        {
          text: vm.$t("register"),
          value: "cadastro",
        },
        {
          text: vm.$t("deposit"),
          value: "deposito",
        },
        {
          text: "Login",
          value: "login",
        },
      ],
    },
    rules: {
      required: validate.required,
    },
  }),

  methods: {
    async createWebhook() {
      if (!this.form.valid) {
        return;
      }

      const res = await this.$request.post(
        `${this.$prefix()}/WebHook/addWebHook`,
        {
          endpoint: this.form.url,
          type: this.form.type,
        }
      );

      if (Array.isArray(res) && res.length === 0) {
        return;
      }

      this.form.url = "";
      this.form.type = "";

      this.$store.commit("setFeedbackSnack", {
        msg: res.messages,
        color: "success",
      });

      this.dialog = false;

      this.$emit("refresh");
    },
    validUrl(str) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$", // fragment locator
        "i"
      );

      return pattern.test(str) || this.$t("urlNo");
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
